import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { financialReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const financialReportRouteMetadata: IRouteMetadataObj<
  typeof financialReportRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/financialReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const financialReportRoutes = createRoute<
  typeof financialReportRoutesObj
>(financialReportRoutesObj, financialReportRouteMetadata);
